import { fetchWithCache, getCachedData } from "../services/apiService";

export const userRealtorSearch = async (name, { setRealtors }) => {
  const cacheKey = `/api/user/realtorSearch_${name}`;

  // Show cached data immediately if available
  const cached = getCachedData(cacheKey, {});
  if (cached) {
    setRealtors(cached);
  }

  try {
    const data = await fetchWithCache(
      "/api/user/realtorSearch",
      {
        method: "POST",
        body: JSON.stringify({ name }),
        cacheKey,
        retries: 2,
        timeout: 10000,
      },
      true,
    );
    setRealtors(data);
  } catch (error) {
    if (!cached) {
      setRealtors([]);
    }
  }
};
